export class Packers {
  packers: Packer[];
  id: string;
  designId: string;
  tubularStringId: string;
  mudlineDepth: number;
  topOfCementMd : number;
  hangerMd: number;
  shoeMd: number;
  isFullyCemented: boolean;
}

export class Packer {
  name: string;
  type: string;
  measuredDepth: number;
  initialSetPressure: number;
  plugDepth: number;
  pickupForce: number;
  hasExpansionJoint: boolean;
  advancedExpansionJoint: AdvancedExpansionJoint;
  isPressureBarrier: boolean;
  packerEnvelope: PackerEnvelope[];
  sort: number;

  constructor(init?: Partial<Packer>) {
    Object.assign(this, init);

    if (this.type == 'Mechanical') {
      this.initialSetPressure = init?.initialSetPressure ?? 0;
      this.plugDepth = init?.plugDepth ?? 0;
    }

    this.packerEnvelope = init?.packerEnvelope || [];
  }
}

export class AdvancedExpansionJoint {
  isDepthNotAtPacker: boolean;
  measuredDepth: number;
  sealBoreContactDiameter: number;
  isSheared: boolean;
  movementState: MovementState;
  notShearedState: NotShearedState;
  sealBoreBelowPacker: boolean;

  constructor(init: Partial<AdvancedExpansionJoint>) {
    Object.assign(this, init);

    this.isSheared = init?.isSheared ?? true;
  }
}
export class MovementState {
  totalStrokeLength?: number;
  hasUpwardNoGo: boolean;
  spaceOut?: number;
}

export class NotShearedState {
  shearPinRating?: number;
}

export class PackerEnvelope {
  public force: number;
  public differentialPressure: number;
}

export class PackerEnvelopeUi {
  public constructor(init?: Partial<PackerEnvelopeUi>) {
    this.selectedPacker = init && init.selectedPacker || null;
  }
  selectedPacker: string;
}


export class PackersUi {
  public constructor(init?: Partial<PackersUi>) {
    this.selectedPacker = init && init.selectedPacker || null;
  }
  selectedPacker: Packer;
}

export enum PackerSchematicDisplayMode {
  CrossSectionalAreas = 'CrossSectionalAreas',
  TubingToPackerForces = 'TubingToPackerForces',
  LatchingForce = 'LatchingForce',
  PackerToCasingForce = 'PackerToCasingForce'
}

export enum ExpansionJointFocus {
  ExpansionJoint = 0,
  PackerBody = 1
}

export class PackerResultsUi {
  public constructor(init?: Partial<PackerResultsUi>) {
    this.selectedPacker = init && init.selectedPacker || null;
    this.selectedResultDisplay = init && init.selectedResultDisplay || 'grid';
    this.selectedResultView = init && init.selectedResultView || 'differentialPressure';
    this.displacementType = init && init.displacementType || 'relativeDisplacements';
  }
  selectedPacker: Packer;
  selectedResultDisplay: string;
  selectedResultView: string;
  displacementType: string;
}
